import {ScoringSystem} from '@legit-health/ui';
import * as Yup from 'yup';
import {createValidatorForScoringSystem} from './createSchema';

const createScoringSystemSchema = (scoringSystems: ScoringSystem[]) =>
  Yup.object().shape(
    scoringSystems.reduce(
      (acc, scoringSystem) => ({
        ...acc,
        [scoringSystem.id]: createValidatorForScoringSystem(scoringSystem)
      }),
      {}
    )
  );

export default createScoringSystemSchema;
